var _g, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNavReports = function SvgIconNavReports(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 85.022,
    viewBox: "0 0 87.405 85.022",
    width: 87.405,
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m827.215 503.94h-44.715a4.814 4.814 0 0 1 -4.814-4.814v-59.982a4.814 4.814 0 0 1 4.814-4.814h33.45l16.079 17.707v47.089a4.814 4.814 0 0 1 -4.814 4.814z",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    transform: "translate(-775.684 -424.392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m837.192 493.636h-44.717a4.814 4.814 0 0 1 -4.814-4.814v-59.982a4.814 4.814 0 0 1 4.814-4.814h33.451l16.08 17.708v47.088a4.814 4.814 0 0 1 -4.814 4.814z",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.548,
    transform: "translate(-778.24 -421.752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m854.809 441.573h-17.3v-17.5z",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.247,
    transform: "translate(-791.012 -421.763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.671 27.457h16.84",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.755 27.457h12.286",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.671 38.105h34.37",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.671 48.752h34.986",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.671 61.094h34.986",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.473 38.855h33.183",
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.124
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.71,
    cy: 57.326,
    r: 27.696
  }), /*#__PURE__*/React.createElement("path", {
    className: "themed-stroke",
    d: "m880.959 499.6h-19.02l10.861 16.12a19.968 19.968 0 0 0 8.159-16.12z",
    stroke: "#3393b9",
    strokeMiterlimit: 10,
    strokeWidth: 2.973,
    transform: "translate(-797.271 -441.116)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "themed-stroke",
    d: "m845.491 491.666v-21.719a21.719 21.719 0 1 0 12.855 39.221z",
    stroke: "#3393b9",
    strokeMiterlimit: 10,
    strokeWidth: 2.973,
    transform: "translate(-787.492 -433.518)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "themed-fill",
    d: "m879.081 486.865a20 20 0 0 0 -20-20v20z",
    fill: "#3393b9",
    transform: "translate(-796.539 -432.729)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNavReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nav-reports.62fb0d88.svg";
export { ForwardRef as ReactComponent };